import { CacheProvider } from '@emotion/react';
import {useState, useEffect} from 'react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from '@mui/stylis-plugin-rtl';
import {muiTheme, muiThemeDark} from "./materialUiTheme.js";
import {ThemeProvider, createTheme} from "@mui/material";
import {useTranslation} from "react-i18next";

function Mui({ mode, children }) {
  const { i18n } = useTranslation();
  const [cache, setCache] = useState(null);
  const [theme, setTheme] = useState(null);

  useEffect(() => {
    // watch for language changes and update theme RTL settings
    let stylisPlugins = [prefixer];
    if (i18n.dir() === 'rtl') {
      stylisPlugins.push(rtlPlugin);
    }
    setCache(createCache({
      key: 'muirtl',
      stylisPlugins: stylisPlugins,
    }));

    const currentTheme = mode === 'dark' ? muiThemeDark : muiTheme;

    currentTheme.direction = i18n.dir();
    setTheme(createTheme(currentTheme));
  }, [i18n, i18n.language, mode]);

  return theme && cache ? (
    <ThemeProvider theme={theme}>
      <CacheProvider value={cache}>
        {children}
      </CacheProvider>
    </ThemeProvider>
  ) : null;
}
export default Mui;
